import { StateUtils } from '@spartacus/core';

export const DOCUMENT_IDENTIFIER_VALIDATOR_PROCESS_ID = 'documentIdentifierValidator';
export const DOCUMENT_IDENTIFIER_VALIDATOR_FEATURE = 'documentIdentifierValidator';

// export interface StateWithDocumentIdentifierValidator {
//   [DOCUMENT_IDENTIFIER_VALIDATOR_FEATURE]: DocumentIdentifierValidatorState;
// }
//
// export interface DocumentIdentifierValidatorState {
//   account: UserDetailsState;
//   addresses: StateUtils.LoaderState<Address[]>;
//   consents: StateUtils.LoaderState<ConsentTemplate[]>;
//   billingCountries: BillingCountriesState;
//   countries: DeliveryCountriesState;
//   payments: StateUtils.LoaderState<PaymentDetails[]>;
//   orders: StateUtils.LoaderState<OrderHistoryList>;
//   order: StateUtils.LoaderState<Order>;
//   replenishmentOrders: StateUtils.LoaderState<ReplenishmentOrderList>;
//   orderReturn: StateUtils.LoaderState<ReturnRequest>;
//   orderReturnList: StateUtils.LoaderState<ReturnRequestList>;
//   titles: TitlesState;
//   regions: StateUtils.LoaderState<RegionsState>;
//   resetPassword: boolean;
//   consignmentTracking: ConsignmentTrackingState;
//   customerCoupons: StateUtils.LoaderState<CustomerCouponSearchResult>;
//   notificationPreferences: StateUtils.LoaderState<NotificationPreference[]>;
//   productInterests: StateUtils.LoaderState<ProductInterestSearchResult>;
//   costCenters: StateUtils.LoaderState<CostCenter[]>;
//   replenishmentOrder: StateUtils.LoaderState<ReplenishmentOrder>;
// }
